import { Box, BoxProps, Flex, SkeletonCircle, SkeletonText } from "@chakra-ui/react";

const Template = (props: BoxProps) => (
    <Box {...props} mb={3}>
        <Flex>
            <SkeletonCircle flexShrink={0} w={5} h={5} mr={1} />
            <Box w="100%">
                <SkeletonText maxWidth={["145px", "140px"]} noOfLines={1} skeletonHeight="21px" mb={0.5} />
                <SkeletonText pb={1} maxWidth="43px" noOfLines={1} skeletonHeight="18px" />

                <SkeletonText pb={1} noOfLines={1} skeletonHeight="21px" />
                <SkeletonText pb={1} maxWidth="430px" noOfLines={1} skeletonHeight="21px" />
                <SkeletonText pt={0.5} maxWidth="145px" noOfLines={1} skeletonHeight="21px" />
            </Box>
        </Flex>
    </Box>
);

export const CommentBlockLoadingState = (props: BoxProps) => {
    return (
        <Box {...props}>
            <Template />
            <Template ml={6} />
            <Template ml={6} />
            <Template />
        </Box>
    );
};
